export const URLAPISUBIDA = 'https://sistemateamtufino.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://sistemateamtufino.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://sistemateamtufino.com/notis/'

export const URLAPISUBIDAPDF = 'https://sistemateamtufino.com/notis/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://sistemateamtufino.com/notis/'